import React, { FC, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ItvHeader } from '../../../components/Itv/ItvHeader';
import { ItvTabsNav } from '../../../components/Itv/ItvTabsNav';
import { Footer } from '../../../components/Footer';
import { useUserContext } from '../../../providers/UserProvider';

import { locale } from '../../../consts';
import { Spinner } from '../../../components/shared/Spinner';
import {
  GetSubNavigationQuery,
  useGetSubNavigationQuery,
} from '../../../libs/graphql/betzoneDirectusAPI/queries/__generated__/get-sub-nav.query.generated';
import { Endpoint } from '../../../models/api.model';
import { ItvSubNav } from '../../../components/Itv/ItvSubNav';
import './ItvMain.scss';
import { AvailableBrands } from '../../../components/Itv/types';
import { BRANDS } from '../../../components/Itv/types';

export const ItvMain: FC = () => {
  const { data: subNavigation, loading } = useGetSubNavigationQuery({
    variables: { language: locale },
    context: { endpoint: Endpoint.betzoneDirectusAPI },
  });
  const { theme } = useUserContext();
  const brandSubNav = (subNavigation as GetSubNavigationQuery)?.[theme as AvailableBrands];

  const subNav = brandSubNav
    ?.map((navItem) => {
      const [data] = navItem.translations || [];

      if (!data) return null;

      return {
        slug: `/${theme}/${data.slug}`,
        title: data.title,
      };
    })
    .filter((item): item is { slug: string; title: string } => item !== null);

  useEffect(() => {
    const portal = document.getElementById('gameCardZoomPortal');

    if (!portal) return;

    // Remove any existing theme classes
    portal.classList.remove('bingo', 'spins', 'prizes');
    // Add new theme class
    portal.classList.add(theme);

    return () => {
      portal.classList.remove(BRANDS.BINGO, BRANDS.SPINS, BRANDS.PRIZES);
    };
  }, [theme]);

  return (
    <div className={`itv-layout ${theme}`}>
      <ItvHeader />
      <div className="itv-layout__main">
        {loading ? (
          <div className="itv-layout__loader">
            <Spinner />
          </div>
        ) : (
          <>
            {subNavigation && <ItvTabsNav subNavigation={subNavigation} />}
            {brandSubNav && <ItvSubNav urls={subNav} />}
            <div className="itv-layout__content">
              <Outlet />
            </div>
          </>
        )}
      </div>

      <Footer isLangSwitcherDisplayed={false} isTimeDisplayed={false} />
    </div>
  );
};
